import { Auth } from "aws-amplify";

export async function signIn(email, password) {
  await Auth.signOut();
  return await Auth.signIn(email, password);
}

export async function currentSession() {
  return await Auth.currentSession();
}

export async function currentUserInfo() {
  return await Auth.currentUserInfo();
}

export async function forgotPassword(email) {
  return await Auth.forgotPassword(email);
}

export async function forgotPasswordSubmit(email, code, password) {
  return await Auth.forgotPasswordSubmit(email, code, password);
}

export async function signUp(username, password, attributes) {
  return Auth.signUp({ username, password, attributes });
}

export async function confirmSignUp(email, otp) {
  return Auth.confirmSignUp(email, otp);
}

export async function resendSignUp(email) {
  return Auth.resendSignUp(email);
}

export async function signOut() {
  return Auth.signOut();
}

export async function changePassword(oldPassword, newPassword) {
  const cognitoUser = await Auth.currentAuthenticatedUser();
  await Auth.changePassword(cognitoUser, oldPassword, newPassword);
}
